import React, { useEffect, useState } from 'react';
import './ProcessingComponent.css';
import {useTranslation} from "react-i18next";
import TestimonialCard from '../../../components/TestimonialCard';

interface Testimonial {
    avatar: string;
    name: string;
    rating: number;
    text: string;
}

interface ProcessingComponentProps {
    message: string;
    time: number;
    onComplete: () => void;
    testimonials?: Testimonial[];
    step: any;
}

export const ProcessingComponent: React.FC<ProcessingComponentProps> = ({
    message,
    time,
    onComplete,
    testimonials = []
}) => {
    const [timeLeft, setTimeLeft] = useState(time);
    const { t} = useTranslation()
    useEffect(() => {
        // Start the countdown
        const timer = setInterval(() => {
            setTimeLeft((prevTime) => {
                if (prevTime <= 1) {
                    clearInterval(timer);
                    onComplete();
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);

        // Cleanup on unmount
        return () => clearInterval(timer);
    }, [time, onComplete]);

    // Calculate progress percentage
    const progress = ((time - timeLeft) / time) * 100;

    return (
        <div className="processing-component">
            <div className="processing-component__content">
                <svg
                    className="processing-component__spinner"
                    width="55"
                    height="55"
                    viewBox="0 0 56 56"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    {Array.from({ length: 12 }).map((_, i) => {
                        // Reverse: leading dot (i=0) is smallest and most transparent, last dot (i=11) is largest and most opaque
                        const angle = (i * 30) * (Math.PI / 180);
                        const r = 22;
                        const cx = 28 + r * Math.cos(angle);
                        const cy = 28 + r * Math.sin(angle);
                        // Opacity: 1 -> 0.3, Radius: 1.5 -> 4.5
                        const opacity = 0.3 + i * 0.07;
                        const radius = 1.5 + (i * (4.5 - 1.5) / 11);
                        const color = '#000000';
                        return (
                            <circle
                                key={i}
                                cx={cx}
                                cy={cy}
                                r={radius}
                                fill={color}
                                opacity={opacity}
                            />
                        );
                    })}
                </svg>
                <h2 className="processing-component__title">{t('processingContentTitle')}</h2>
                <p className="processing-component__description">{message}</p>
                <div className="processing-component__progress-bar">
                    <div
                        className="processing-component__progress-fill"
                        style={{ width: `${progress}%` }}
                    />
                </div>
                {testimonials.length > 0 && (
                    <div className="processing-component__testimonials">
                        <h3 className="processing-component__testimonials-title">{t('processingCommentSub')}</h3>
                        {testimonials.map((item, idx) => (
                            <TestimonialCard key={idx} avatar={item.avatar} name={item.name} rating={item.rating} text={item.text} />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};
